<template>
  <transition name="slide">
    <div v-show="expanded" class="bold-options-group">
      <div v-if="showLabelBold" class="panel-block" style="padding-left: 2rem">
        <label class="checkbox">
          <input
            :checked="labelBold"
            type="checkbox"
            :data-test-id="`bold-${testIdPrefix}-label-checkbox`"
            @change="$emit('update:labelBold', $event.target.checked)"
          />
          <span class="ml-2">Bold "{{ labelText }}" label</span>
        </label>
      </div>
      <div class="panel-block" style="padding-left: 2rem">
        <label
          class="checkbox is-flex is-align-items-center is-fullwidth is-justify-content-space-between"
        >
          <span class="is-flex is-align-items-center">
            <input
              :checked="textBold"
              type="checkbox"
              :data-test-id="`bold-${textTestIdPrefix || testIdPrefix}-checkbox`"
              @change="$emit('update:textBold', $event.target.checked)"
            />
            <span class="ml-2">{{ textBoldLabel }}</span>
          </span>
          <IconHint v-if="hintContent" :content="hintContent" />
        </label>
      </div>
      <slot />
    </div>
  </transition>
</template>

<script setup>
  import IconHint from "../icon-hint.vue";

  defineProps({
    expanded: { type: Boolean, default: false },
    labelText: { type: String, default: "" },
    labelBold: { type: Boolean, default: false },
    textBold: { type: Boolean, default: false },
    textBoldLabel: { type: String, default: "Bold text" },
    testIdPrefix: { type: String, required: true },
    textTestIdPrefix: { type: String, default: null },
    hintContent: { type: String, default: null },
    showLabelBold: { type: Boolean, default: true },
  });

  defineEmits(["update:labelBold", "update:textBold"]);
</script>

<style lang="scss" scoped>
  .bold-options-group > .panel-block {
    border-bottom: 1px solid #ededed;
    border-radius: 0;
  }

  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.3s ease;
    max-height: 500px;
    overflow: hidden;
  }

  .slide-enter-from,
  .slide-leave-to {
    max-height: 0;
    opacity: 0;
  }
</style>
